/** @format */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';
import { withStyles } from '@material-ui/core/styles';
import I18n from '../components/Translate/I18n';
import COLORS from '../assets/themes/OPL/colors';

const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
};

const styles1 = (theme) => ({
    success: {
        backgroundColor: COLORS.FUNCTION.SUCCESS,
    },
    error: {
        backgroundColor: COLORS.FUNCTION.DANGER,
    },
    alert: {
        //ERROR ALIAS
        backgroundColor: COLORS.FUNCTION.DANGER,
    },
    danger: {
        //ERROR ALIAS
        backgroundColor: COLORS.FUNCTION.DANGER,
    },
    info: {
        backgroundColor: COLORS.FUNCTION.INFO,
    },
    warning: {
        backgroundColor: COLORS.FUNCTION.WARNING,
    },
    icon: {
        fontSize: 20,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(),
    },
    message: {
        fontFamily: '"Helvetica 55 Roman", "Helvetica 75", "Arial"',
        display: 'flex',
        alignItems: 'center',
    },
});

function SnackBarMessageWraper(props) {
    const { classes, className, message, onClose, variant, ...other } = props;
    const Icon = variantIcon[variant];

    return (
        <SnackbarContent
            className={classNames(classes[variant], className)}
            aria-describedby="client-snackbar"
            message={
                <span id="client-snackbar" className={classes.message}>
                    <Icon className={classNames(classes.icon, classes.iconVariant)} />
                    <I18n trans={message} />
                </span>
            }
            action={[
                <IconButton key="close" aria-label="Close" color="inherit" className={classes.close} onClick={onClose}>
                    <CloseIcon className={classes.icon} />
                </IconButton>,
            ]}
            {...other}
        />
    );
}

SnackBarMessageWraper.propTypes = {
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    message: PropTypes.node,
    onClose: PropTypes.func,
    variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired,
};

const SnackbarContentWrapper = withStyles(styles1)(SnackBarMessageWraper);

const styles2 = (theme) => ({
    margin: {
        margin: theme.spacing(),
    },
});

class SnackBarMessage extends React.Component {
    handleClose = (event, reason) => {
        const { closeCallback } = this.props;
        closeCallback();
    };

    render() {
        const { text, variant, open } = this.props;
        return (
            <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                open={open}
                autoHideDuration={6000}
                onClose={this.handleClose}
            >
                <SnackbarContentWrapper onClose={this.handleClose} variant={variant} message={text} />
            </Snackbar>
        );
    }
}

SnackBarMessage.propTypes = {
    classes: PropTypes.object.isRequired,
    text: PropTypes.string.isRequired,
    variant: PropTypes.string.isRequired,
    closeCallback: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};

export default withStyles(styles2)(SnackBarMessage);
